// CloudFront (and similar) geo headers on geolocation.alo.software are returned
// as { "header-name": { value: "..." } } when ?headers is set.

export const geolocationHeaderValue = (headers, name) => {
  if (!headers || !name) return ''
  const entry = headers[name]
  if (entry == null) return ''
  if (typeof entry === 'string') return entry.trim()
  if (typeof entry === 'object' && entry.value != null) {
    return String(entry.value).trim()
  }
  return ''
}

const CLOUDFRONT_COUNTRY = 'cloudfront-viewer-country'
const CLOUDFRONT_REGION = 'cloudfront-viewer-country-region'
const CLOUDFRONT_REGION_NAME = 'cloudfront-viewer-country-region-name'

// Maps ?headers (and legacy { country_code }) into a stable shape for callers.
export const normalizeGeolocationResponse = (data) => {
  if (!data || typeof data !== 'object') return {}

  const fromHeaders = Boolean(
    data[CLOUDFRONT_COUNTRY] || data[CLOUDFRONT_REGION]
  )

  const country_code =
    data.country_code ||
    geolocationHeaderValue(data, CLOUDFRONT_COUNTRY)

  const region_code =
    data.region_code ||
    geolocationHeaderValue(data, CLOUDFRONT_REGION)

  const region_name =
    data.region_name ||
    geolocationHeaderValue(data, CLOUDFRONT_REGION_NAME)

  if (!fromHeaders && data.country_code) {
    return {
      ...data,
      region_code: region_code || data.region || data.state_code || '',
      region_name: region_name || data.state || ''
    }
  }

  return {
    ...data,
    country_code,
    region_code,
    region_name,
    region: region_code || region_name || data.region || ''
  }
}
